import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetFieldConceptIndexingStatusParams {
  readonly field_concept_uri: string;
}

export type FieldConceptIndexingStatusCode = 'INDEXING_STATUS_UNSPECIFIED' | 'INDEXING_IN_PROGRESS' | 'INDEXING_PENDING' | 'INDEXING_FAILED_RETRY_PENDING' | 'INDEXING_FAILED' | 'INDEXING_COMPLETE' | 'INDEXING_UNSUPPORTED';
export type FieldConceptIndexingErrorCode = 'INDEXING_VALUE_LENGTH_EXCEEDED_ERROR' | string; // All other errors are in backend and for debugging only, the user can't fix them.

export interface IGetFieldConceptIndexingStatusResult {
  readonly fieldConceptIndexingStatusCode: FieldConceptIndexingStatusCode;
  readonly fieldConceptIndexingErrorCode: FieldConceptIndexingErrorCode;
}
export class GetFieldConceptIndexingStatusRequest extends Request<IGetFieldConceptIndexingStatusParams, IGetFieldConceptIndexingStatusResult> {
  constructor(params: IGetFieldConceptIndexingStatusParams) {
    super('getIndexingStatus', params);
  }
}
